<template>
  <CustomPage
    title="订单详情"
    :subtitle="subtitle"
    :noBorder="true"
    backRoute="Order"
    style="background: #f7f7f7"
  >
    <div slot="content">
      <div class="in-sale-container pb-12">
        <Header :data="data" />
        <div class="body">
          <div class="amount-panel-container flex flex-col">
            <img
              src="@/assets/order/shouhuodizhi.svg"
              class="w-full flex-grow-0"
              alt=""
            />
            <div class="flex-grow p-3">
              <div class="font-medium">
                {{ data.recipients }}&nbsp;{{ data.recipientsMobile }}
              </div>
              <div class="text-sm" style="color: #999999">
                {{ data.areaName }}
              </div>
            </div>
          </div>
          <MainPanel :data="data" />
          <AmountPanel :data="data" />
        </div>
      </div>
      <div class="footer items-center" v-if="data">
        <div
          v-if="
            data.state === 'INITIAL' ||
            (data.state === 'PAID' && data.deliverState !== 'PREPARING')
          "
          class="btn van-hairline--surround"
          @click="showCancelOrder = true"
        >
          取消订单
        </div>
        <template v-if="data.state === 'INITIAL'">
          <div v-if="noPurchase === true" class="no-purchase">超出活动限购</div>
          <div
            v-else
            class="
              bg-red
              rounded-full
              text-white text-sm
              h-7
              leading-7
              px-3
              mx-1
            "
            style="white-space: nowrap"
            @click="pay"
          >
            去付款
          </div>
        </template>

        <div
          v-show="data.state === 'SHIPPED' || data.state === 'COMPLETED'"
          class="btn van-hairline--surround"
          @click="
            $router.push({ name: 'OrderInSaleLocus', query: { id: orderNo } })
          "
        >
          查看物流
        </div>
        <div
          v-show="data.state === 'SHIPPED'"
          class="bg-red rounded-full text-white text-sm h-7 leading-7 px-3 mx-1"
          style="white-space: nowrap"
          @click="confirmOrder"
        >
          确认收货
        </div>
        <div
          v-show="
            data.state === 'COMPLETED' && data.aftSaleState !== 'TERMINATED'
          "
          class="btn van-hairline--surround"
          @click="showAftSale = true"
        >
          申诉售后
        </div>
      </div>
      <ActionSheet v-model="showCancelOrder" title="取消订单">
        <div class="content px-3">
          <div class="px-4">取消后无法恢复优惠券/红包</div>
          <div style="color: #808080" class="text-sm px-4">
            请选择取消订单原因
          </div>
          <RadioGroup v-model="cancelReason">
            <CellGroup>
              <Cell
                title="价格有点贵"
                clickable
                @click="cancelReason = '价格有点贵'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="价格有点贵" />
                </template>
              </Cell>
              <Cell
                title="规格/款式/数量拍错"
                clickable
                @click="cancelReason = '规格/款式/数量拍错'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="规格/款式/数量拍错" />
                </template> </Cell
              ><Cell
                title="收货地址拍错"
                clickable
                @click="cancelReason = '收货地址拍错'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="收货地址拍错" />
                </template> </Cell
              ><Cell
                title="暂时不需要了"
                clickable
                @click="cancelReason = '暂时不需要了'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="暂时不需要了" />
                </template> </Cell
              ><Cell title="其他" clickable @click="cancelReason = '其他'">
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="其他" />
                </template>
              </Cell>
            </CellGroup>
          </RadioGroup>
          <div class="flex justify-center my-3">
            <Button
              size="large"
              style="
                box-sizing: border-box;
                border-top-left-radius: 9999px;
                border-bottom-left-radius: 9999px;
                border-right: 0px;
                border-color: #e82035;
                color: #e82035;
                height: 32px;
                width: 40%;
              "
              @click="showCancelOrder = false"
              >暂不取消</Button
            >
            <Button
              size="large"
              style="
                box-sizing: border-box;

                border-top-right-radius: 9999px;
                border-bottom-right-radius: 9999px;
                border-left: 0px;
                background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
                color: white;
                border-color: #e82035;

                width: 40%;
                height: 32px;
              "
              @click="cancelInSale"
              >确定取消</Button
            >
          </div>
        </div>
      </ActionSheet>
      <ActionSheet v-model="showAftSale" title="申诉售后">
        <div class="content px-3">
          <div class="px-4">售后客服会快速处理</div>
          <div style="color: #808080" class="text-sm px-4">请选择服务类型</div>
          <RadioGroup v-model="aftSaleReason">
            <CellGroup>
              <Cell
                title="我要退款（无需退货）"
                clickable
                @click="aftSaleReason = '我要退款（无需退货）'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="我要退款（无需退货）" />
                </template>
              </Cell>
              <Cell
                title="我要退货退款"
                clickable
                @click="aftSaleReason = '我要退货退款'"
              >
                <template #right-icon>
                  <Radio checked-color="#ee0a24" name="我要退货退款" />
                </template>
              </Cell>
            </CellGroup>
          </RadioGroup>
          <div class="flex justify-center my-3">
            <Button
              size="large"
              style="
                box-sizing: border-box;
                border-top-left-radius: 9999px;
                border-bottom-left-radius: 9999px;
                border-right: 0px;
                border-color: #e82035;
                color: #e82035;
                height: 32px;
                width: 40%;
                font-size: 14px;
              "
              @click="showAftSale = false"
              >取消申诉</Button
            >
            <Button
              size="large"
              style="
                box-sizing: border-box;

                border-top-right-radius: 9999px;
                border-bottom-right-radius: 9999px;
                border-left: 0px;
                background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
                color: white;
                border-color: #e82035;

                width: 40%;
                height: 32px;
                font-size: 14px;
              "
              @click="wantAftSale"
              >确定申诉</Button
            >
          </div>
        </div>
      </ActionSheet>
      <ActionSheet
        v-model="showPayment"
        title="选择付款方式"
        class="font-semibold text-sm"
      >
        <div v-if="paymentChannelList.length" class="content px-5">
          <div
            class="flex justify-between items-center my-3"
            @click="goPay(paymentChannelList[0])"
          >
            <div class="flex items-center">
              <img class="mr-2" src="@/assets/order/余额.svg" alt="" /><span>{{
                paymentChannelList[0].name
              }}</span>
            </div>
            <div>{{ paymentChannelList[0].withdrawAmount + "元" }}</div>
          </div>
          <div style="color: #808080">第三方支付</div>
          <div
            v-show="data.actualPayAmount > 0"
            v-for="(channel, index) in paymentChannelList"
            :key="channel.code"
            class="flex justify-between items-center my-3"
            @click="goPay(channel)"
          >
            <div v-if="index" class="flex items-center">
              <img
                v-if="channel.code === 'ALI'"
                class="mr-2"
                src="@/assets/order/支付宝.svg"
                alt=""
              />
              <img
                v-else-if="channel.code === 'WX'"
                class="mr-2"
                src="@/assets/order/微信钱包.svg"
                alt=""
              />
              <img v-else class="mr-2" :src="channel.logo" alt="" /><span>{{
                channel.name
              }}</span>
            </div>
            <div></div>
          </div>
          <div v-show="data.actualPayAmount <= 0" class="font-normal py-2">
            无需第三方支付
          </div>
        </div>
      </ActionSheet>
      <ActionSheet
        v-model="showPasswordInput"
        title="请输入支付密码"
        class="text-sm pb-64"
      >
        <div class="w-full text-center">余额支付</div>
        <div class="w-full text-center text-3xl">￥{{ payAmount }}</div>
        <PasswordInput
          :value="password"
          :focused="showPasswordInput"
          @focus="showPasswordInput = true"
        />
        <!-- 数字键盘 -->
        <NumberKeyboard
          v-model="password"
          :show="showPasswordInput"
          @blur="showPasswordInput = false"
        />
      </ActionSheet>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import Bus from "@/utils/bus";
import browserType from "@/utils/browserType";
import browserTypeAdapter from "@/utils/browserTypeAdapter";
import { getToken } from "@/utils/auth";
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import Header from "./components/Header";
import MainPanel from "./components/MainPanel";
import AmountPanel from "./components/AmountPanel";
import { cancelInSale, getInSaleDetail } from "@/api/order/inSale";
import { confirmOrder } from "./webApi";
import {
  getPayChannels,
  orderPay,
  getBillInfo,
  payByBalance,
  payByWxH5,
  payByWxJsapi,
  payByAliH5,
  payPasswordExists,
} from "@/api/pay.js";
import { getAppId } from "@/api/login";
import { areaList } from "@vant/area-data";
import {
  // Icon,
  // Field
  Radio,
  RadioGroup,
  Cell,
  CellGroup,
  // SubmitBar,
  ActionSheet,
  Button,
  Toast,
  PasswordInput,
  NumberKeyboard,
} from "vant";
export default {
  components: {
    CustomView,
    CustomPage,
    Header,
    MainPanel,
    AmountPanel,
    ActionSheet,
    PasswordInput,
    NumberKeyboard,
    Radio,
    RadioGroup,
    ActionSheet,
    Button,
    Cell,
    CellGroup,
  },
  data() {
    return {
      browserTypeStr: null,
      areaList,
      orderNo: null,
      interval: null,
      subtitle: null,
      data: {},
      noPurchase: null,
      showCancelOrder: false,
      showAftSale: false,
      cancelReason: null,
      aftSaleReason: null,
      showPayment: false,
      paymentChannelList: [],
      billId: null,
      payAmount: 0,
      showPasswordInput: false,
      password: "",
      payPasswordExist: false,
    };
  },
  created() {
    this.orderNo = this.$route.query.id;
    this.noPurchase = this.$route.query.noPurchase;
    console.log("this.$route.query.id", this.$route.query.id);
    this.getData();
    // Bus.$on("refreshDataInSale", this.getData);
    if (this.$route.query.code) {
      const _this = this;
      payByWxJsapi({
        billId: this.$route.query.billId,
        code: this.$route.query.code,
      })
        .then((res) => {
          // res.data是{appid:...,timestamp:...}

          function onBridgeReady() {
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              res.data,
              function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  _this.$store.dispatch("app/hideLoading");
                  Toast({
                    message: "支付完成",
                    position: "center",
                    duration: 1000,
                  });
                  _this.$router.replace({
                    path: "/mine/order",
                    query: { active: 2, backRoute: "Mine" },
                  });
                } else {
                  Toast({
                    message: "支付失败",
                    position: "center",
                    duration: 1000,
                  });
                  _this.$router.replace({
                    path: "/mine/order",
                    query: { active: 1, backRoute: "Mine" },
                  });
                }
              }
            );
          }
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
            }
          } else {
            onBridgeReady();
          }
        })
        .catch((e) => {
          this.$store.dispatch("app/hideLoading");
        });
    } else {
      if (this.$route.query.goto === "查看物流") {
        this.$router.push({
          name: "OrderInSaleLocus",
          query: { id: this.orderNo },
        });
      } else if (this.$route.query.goto === "取消订单") {
        this.showCancelOrder = true;
      } else if (this.$route.query.goto === "去付款") {
        this.pay();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getData() {
      console.log(222222222228888);
      this.$store.dispatch("app/showLoading");
      getInSaleDetail(this.orderNo)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.data = this.converData(res.data);
          if (
            this.data.state === "INITIAL" &&
            this.dayjs(res.data.createTime).add(30, "minute") > this.dayjs()
          ) {
            let deadline = this.dayjs(res.data.createTime).add(30, "minute");

            this.interval = setInterval(() => {
              let remainTime = deadline.diff(this.dayjs(), "second");
              this.subtitle =
                "若 " +
                Math.floor(remainTime / 60) +
                "分" +
                ((remainTime % 60) + "").padStart(2, "0") +
                "秒 内未付款将取消订单";
              if (remainTime < 0) {
                clearInterval(this.interval);
                this.getData();
                Bus.$emit("refreshDataInSale", this.orderNo);
              }
            }, 1000);
          }
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    cancelInSale() {
      if (!this.cancelReason) return;
      this.showCancelOrder = false;
      this.$store.dispatch("app/showLoading");
      cancelInSale({ orderNo: this.orderNo, cancelReason: this.cancelReason })
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.getData();
          Bus.$emit("refreshDataInSale", this.orderNo);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    wantAftSale() {
      if (!this.aftSaleReason) return;
      this.showAftSale = false;

      // 如果是套组
      if (this.data.suite) {
        const temp = this.data.items.map((item) => {
          return {
            orderItemId: item.id,
            qty: item.qty,
            imgUrl: item.goodsInfoImg,
            actPrice: item.actPrice,
            spec: item.spec,
          };
        });
        this.$router.replace({
          name: "ApplyAftSale",
          params: {
            id: this.orderNo,
            items: temp,
            aftSaleReason: this.aftSaleReason,
            actId: this.data.actId,
            allRefund: true,
          },
        });
      } else {
        this.$router.push({
          name: "ChooseAftSaleGoods",
          params: {
            id: this.orderNo,
            aftSaleReason: this.aftSaleReason,
            items: this.data.items,
            actId: this.data.actId,
          },
        });
      }
    },
    readLocus(data) {
      let type = data.state === "REFUSED_REFUND" ? "SUPPLIER" : "CUSTOMER";
      const i = data.delivery.find((item) => item.type === type);
      this.$router.push({
        name: "OrderInSaleLocus",
        query: { ...i },
      });
    },
    converData(data) {
      const province =
        this.areaList.province_list[data.shippingAddress.province];
      const city = this.areaList.city_list[data.shippingAddress.city];
      const county = this.areaList.county_list[data.shippingAddress.area];
      data.areaName = `${province} ${city} ${county} ${data.shippingAddress.address}`;
      data.recipients = data.shippingAddress.recipients;
      data.recipientsMobile = data.shippingAddress.recipientsMobile;
      return data;
    },
    confirmOrder() {
      confirmOrder(this.orderNo).then((res) => {
        this.getData();
        Bus.$emit("refreshDataInSale", this.orderNo);
      });
    },
    pay() {
      this.$store.dispatch("app/showLoading");
      // this.browserTypeStr =
      //   localStorage.getItem("browserType") || browserType();
      this.browserTypeStr =
        localStorage.getItem("browserTypeAdapter") || browserTypeAdapter();
      // MARK:
      console.log("browserTypeAdapter");
      console.log(this.browserTypeStr);
      getPayChannels({ targetId: this.orderNo })
        .then(({ data }) => {
          this.paymentChannelList = data;
          this.showPayment = true;
          this.$store.dispatch("app/hideLoading");
          if (this.browserTypeStr === "miniprogram") {
            this.paymentChannelList = this.paymentChannelList.filter(
              (paymentChannel) => {
                return !(paymentChannel.code === "ALI");
              }
            );
          }
        })
        .catch((e) => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    goPay(channel) {
      if (
        channel.code === "BALANCE" &&
        channel.withdrawAmount < this.data.actualPayAmount
      ) {
        return Toast({
          message: "余额不足,请选择其他付款方式",
          position: "center",
          duration: 1000,
        });
      }
      if (this.billId && channel.code === "BALANCE") {
        if (this.payPasswordExist) {
          this.showPasswordInput = true;
        } else {
          Toast({
            message: "未设置支付密码",
            position: "center",
            duration: 1000,
          });
        }
        return;
      }
      if (channel.available) {
        this.showPayment = false;
        this.$store.dispatch("app/showLoading");
        orderPay({ targetId: this.orderNo, channel: channel.code }).then(
          ({ data }) => {
            this.billId = data;
            getBillInfo(this.billId).then(({ data }) => {
              this.payAmount = data.amount;
              if (data.channel === "BALANCE") {
                payPasswordExists().then(({ data }) => {
                  if (data) {
                    this.showPasswordInput = true;
                    this.payPasswordExist = true;
                  } else {
                    Toast({
                      message: "未设置支付密码",
                      position: "center",
                      duration: 1000,
                    });
                  }
                });
              } else if (data.channel === "WX") {
                this.$store.dispatch("app/showLoading");

                if (this.browserTypeStr === "pc") {
                  console.log("pc");
                  // getAppId()
                  //   .then((res) => {
                  //     this.wechatAuth(res.data);
                  //   })
                  //   .catch(() => {
                  this.$store.dispatch("app/hideLoading");
                  //   });
                } else if (this.browserTypeStr === "miniprogram") {
                  const token = getToken();
                  const Authorization = "Bearer " + token;
                  // MARK:
                  // 当前环境是 小程序
                  console.log("miniprogram");
                  // 然后使用 this.wxjs.miniProgram.navigateTo 进行跳转 小程序中的页面
                  //小程序的支付地址
                  console.log(this.wxjs.miniProgram);
                  this.wxjs.miniProgram.navigateTo({
                    url: `../wxpay/wxpay?billId=${this.billId}&Authorization=${Authorization}`,
                    success: function (res) {
                      console.log("res success 跳转小程序成功", res);
                    },
                    fail: function (res) {
                      console.log("res fail 跳转失败", res);
                    },
                  });
                }
                // MARK:
                else if (this.browserTypeStr === "weixin") {
                  console.log("weixin");
                  getAppId()
                    .then((res) => {
                      this.wechatAuth(res.data);
                    })
                    .catch(() => {
                      this.$store.dispatch("app/hideLoading");
                    });
                } else {
                  console.log("mobile");
                  payByWxH5({ billId: this.billId })
                    .then((res) => {
                      let href =
                        res.data +
                        "&redirect_url=" +
                        encodeURIComponent(
                          window.location.origin +
                            this.$route.path +
                            "?id=" +
                            this.orderNo +
                            "&fromWx=true"
                        );
                      // alert(href);
                      window.location.href = href;

                      this.$store.dispatch("app/hideLoading");
                    })
                    .catch((e) => {
                      this.$store.dispatch("app/hideLoading");
                    });
                }
              } else if (data.channel === "ALI") {
                this.$store.dispatch("app/showLoading");

                if (this.browserTypeStr === "pc") {
                  console.log("pc");
                } else if (this.browserTypeStr === "weixin") {
                  console.log("weixin");
                  payByAliH5({
                    billId: this.billId,
                    returnUrl:
                      window.location.origin +
                      this.$route.path +
                      "?id=" +
                      this.orderNo +
                      "&fromAli=true",
                    quitUrl:
                      window.location.origin +
                      this.$route.path +
                      "?id=" +
                      this.orderNo +
                      "&fromAli=true",
                  })
                    .then((res) => {
                      // alert(res.data);
                      var form = res.data;
                      const div = document.createElement("div");
                      div.innerHTML = form;
                      document.body.appendChild(div);
                      document.forms[0].acceptCharset = "utf-8";
                      var queryParam = "";
                      Array.prototype.slice
                        .call(document.querySelectorAll("input[type=hidden]"))
                        .forEach(function (ele) {
                          queryParam +=
                            "&" +
                            ele.name +
                            "=" +
                            encodeURIComponent(ele.value);
                        });
                      var gotoUrl =
                        document.querySelector("form").getAttribute("action") +
                        "&" +
                        queryParam;
                      _AP.pay(gotoUrl);

                      this.$store.dispatch("app/hideLoading");
                    })
                    .catch((e) => {
                      this.$store.dispatch("app/hideLoading");
                    });
                } else {
                  console.log("mobile");
                  payByAliH5({
                    billId: this.billId,
                    returnUrl:
                      window.location.origin +
                      this.$route.path +
                      "?id=" +
                      this.orderNo +
                      "&fromAli=true",
                    quitUrl:
                      window.location.origin +
                      this.$route.path +
                      "?id=" +
                      this.orderNo +
                      "&fromAli=true",
                  })
                    .then((res) => {
                      // alert(res.data);
                      const div = document.createElement("div");

                      div.innerHTML = res.data;
                      document.body.appendChild(div);
                      document.forms[0].submit();

                      this.$store.dispatch("app/hideLoading");
                    })
                    .catch((e) => {
                      this.$store.dispatch("app/hideLoading");
                    });
                }
              }
              this.$store.dispatch("app/hideLoading");
            });
          }
        );
      } else {
        Toast({
          message: channel.reason,
          position: "center",
          duration: 1000,
        });
      }
    },
    wechatAuth(appId) {
      const href =
        window.location.origin +
        this.$route.path +
        "?" +
        this.filterCodeByParams(["billId=" + this.billId]);

      // alert(href);
      const redirect_uri = encodeURIComponent(href);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    },
    // 过滤掉 code 参数
    filterCodeByParams(queryList = []) {
      for (const key in this.$route.query) {
        if (Object.hasOwnProperty.call(this.$route.query, key)) {
          if (key !== "code" && key !== "goto") {
            queryList.push(`${key}=${this.$route.query[key]}`);
          }
        }
      }
      return queryList.join("&");
    },
  },
  watch: {
    password(value) {
      if (value.length === 6) {
        this.$store.dispatch("app/showLoading");
        payByBalance({ billId: this.billId, password: value })
          .then((res) => {
            this.$store.dispatch("app/hideLoading");
            Toast({
              message: res.data ? "支付成功" : "支付失败",
              position: "center",
              duration: 1000,
            });
            Bus.$emit("refreshDataInSale", this.orderNo);

            this.$router.push({ path: "/mine/order", query: { active: 2 } });
          })
          .catch((e) => {
            // Toast({
            //   message: e.toString(),
            //   position: "center",
            //   duration: 1000,
            // });
            this.password = "";
            this.$store.dispatch("app/hideLoading");
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.in-sale-container {
  .body {
    padding: 0 24px;
    margin-top: -98px;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;
  .btn {
    font-size: 28px;
    color: #666666;
    line-height: 28px;
    padding: 15px 20px;
    margin: 22px 4px 20px;
    & + .btn {
      margin-left: 20px;
    }
    &::after {
      border-radius: 56px;
      border-color: #979797;
    }
  }
}
.amount-panel-container {
  margin: 28px 0 28px 0;

  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
}
.no-purchase {
  margin-left: 20px;
  color: #acacac;
  font-size: 24px;
}
</style>
